
import dispointHeader from '../components/dispoint-header.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Icon from 'vux/src/components/icon/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import { common, commonApi, check } from '@/common/index'
import { validataNumber } from '@/common/utils/validate.js'
import { deepClone } from '@/common/utils/index.js'
import getPayInfoMX from '../mixins/getPayInfo.js'
import publicMX from '../../mixins/publicMX.js'
let normalAmountLists = [100, 500, 1000, 2000]
export default {
directives: {
TransferDom
},
mixins: [getPayInfoMX, publicMX],
components: {
XButton,
Group,
XInput,
Icon,
Confirm,
dispointHeader
},
data() {
return {
payLists: [],
deposit: { imgUrl: '', amount: '', payerName: '' },
amountLists: deepClone(normalAmountLists)
}
},
methods: {
handSelectBank(item) {
this.paySelected = item
this.deposit.amount = ''
this._setAmountLists()
},

_setAmountLists() { // 重置选择金额列表

let { hasFixedAmount, amountType, fixedAmountList, depositMax, depositMin  } = this.paySelected
if (this.paySelected.fixedAmountList !== '') {
this.amountLists = this.paySelected.fixedAmountList.split(',')
} else {
this.amountLists = []
let a = depositMax - depositMin
let c = 4
if (a > 50) {
if (a > 20000) c = 8
let b = Math.floor(a / c)
for(let i = 0; i < c; i++) {
if (i === 0) {
this.amountLists.push(depositMin)
} else if (i === (c - 1)) {
this.amountLists.push(depositMax)
} else {
let d = b * (i + 1) + depositMin
let f = d > 200 ? ((d / 100).toFixed(0)) * 100 : d
this.amountLists.push(f)
}
}
} else {
this.amountLists = [depositMin, depositMax]
}
}
},

implementationFetched(data) { // 获取数据后续处理
this._setAmountLists()
},

handeNext() { // 提交支付
if (!this.checkSubmit()) return

let params = {

payDomain: '/api/indexpay/apppay_gateway', // newDepositUrl
amount: this.deposit.amount,
payType: this.paySelected.payType,
payConfigId: this.paySelected.id,
userId: this.$store.state.UUID,
}
common.newDepositUrl(params); 
},

checkSubmit() { // 验证是否可以提交
const { amount } = this.deposit
const { depositMin, depositMax } = this.paySelected
if (!validataNumber(amount) || (validataNumber(amount) && (amount * 1 > depositMax || amount * 1 < depositMin))) {
this.$vux.toast.show({ text: this.$t('Deposit').saveMoneyNumPlace + `${depositMin} ~ ${depositMax}`, type: 'cancel' })
return
}
return true
}
}
};



// WEBPACK FOOTER //
// ./src/pages/build800/views/SaveMonery/Recharge/index.vue